export const WIND = 'WIND';
export const SOLAR = 'SOLAR';
export const LOAD = 'LOAD';
